
export enum AdminRoles {
   SUPER_ADMIN = 'SUPER_ADMIN',
   BLOGGER = 'BLOGGER',
   ACCOUNTANT = 'ACCOUNTANT',
   CRM = 'CRM',
}
